export default __webpack_public_path__ + "static/media/Ativo_15@4x_1@3x.c08f36f6.png";